<template>
  <van-overlay :show="show">
    <div class="overlay-container">
      <div class="overlay-coupon">
        <div class="overlay-coupon--title">
          {{ coupon.couponName | formatTitle }}
        </div>
        <div class="overlay-coupon--time">
          活动时间：{{ coupon.startTime | formatTime }}-{{ coupon.endTime | formatTime }}
        </div>
        <div class="overlay-coupon--take-box" @click="takeCoupon(coupon.denominationId)">
          <div class="overlay-coupon--price">
            ￥<span>{{ coupon.preferentialContent }}</span>
          </div>
        </div>
        <i class="overlay--close-btn" @click="show = false" />
      </div>
    </div>
  </van-overlay>
</template>

<script>
import moment from 'moment'
import { getLatestCouponByPosition, takeCouponBatch } from '@/api/coupon'

export default {
  name: 'CouponOverlay',
  data() {
    return {
      show: false,
      coupon: {}
    }
  },
  filters: {
    formatTime: (value, f = 'M.D') => (value ? moment(value).format(f) : ''),
    formatTitle: title => (title ? (title.length > 10 ? title.substring(0, 10) + '...' : title) : '')
  },
  mounted() {
    this.loadCoupon()
  },
  activated() {
    if (this.show) {
      this.show = false

      setTimeout(() => {
        this.loadCoupon()
      }, 200)
    }
  },
  methods: {
    /**
     * 加载优惠券
     */
    loadCoupon() {
      getLatestCouponByPosition({
        placementType: 1
      }).then(res => {
        let result = res.data.data
        if (result) {
          this.coupon = result
          this.show = true
        }
      })
    },

    /**
     * 领取优惠券
     */
    takeCoupon(id) {
      takeCouponBatch([id]).then(() => {
        this.$toast.success('领取成功')
        this.show = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.overlay {
  &-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  &-coupon {
    width: 100%;
    height: 397px;
    background-image: url('~@/assets/images/puhui/coupon-bg.png');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: center;
    text-align: center;
    position: relative;

    &--title {
      margin-top: 107px;
      font-size: 21px;
      color: #fff;
    }

    &--time {
      margin-top: 20px;
      display: inline-block;
      font-size: 11px;
      padding: 6px 13px;
      color: #fff;
      border: 1px solid #fff;
    }

    &--take-box {
      margin-top: 16px;
      width: 216px;
      height: 65px;
      margin: 16px auto;
      position: relative;
      background-image: url('~@/assets/images/puhui/ticket.png');
      background-size: 100%;
      background-repeat: no-repeat;
      background-position-y: center;
    }

    &--price {
      position: absolute;
      left: 15px;
      top: 50%;
      font-size: 20px;
      margin-top: -20px;
      color: #fc140f;

      span {
        font-size: 40px;
        font-weight: 400;
        color: #fc140f;
      }
    }
  }

  &--close-btn {
    width: 42px;
    height: 40px;
    position: absolute;
    left: 50%;
    bottom: 0;
    margin-left: -20px;
    border-radius: 25px;
  }
}
</style>
